export const CREATED_NODE_IDS = `WPGQL-created-node-ids`
export const LAST_COMPLETED_SOURCE_TIME = `WPGQL-last-completed-source-time`
export const MD5_CACHE_KEY = `introspection-node-query-md5`
